import { BFormSelect } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormSelect = createEgBootstrapProxy(
  "EgBFormSelect",
  BFormSelect
);
